/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/named */

import React, { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { Test } from 'Src/containers/Test'
import { PublicPageContainer } from 'Pages/root'
import { ExternalFormsRoutes, OrdersRoutes } from 'Pages/orders'
import { CompanyRoutes } from 'Pages/company/routes'
import { KnowledgesRoutes } from 'Pages/knowledge'
import { ColiseumRoutes } from 'Pages/coliseum/routes'
import { LibraryRoutes } from 'Pages/library/routes'
import { RegistratorCabinetRoutes } from 'Pages/registratorCabinet'
import { ActsRoutes } from 'Pages/acts'
import { LogsRoutes } from 'Pages/logs'
import { SurveyRoutes } from 'Pages/survey/routes'
import { AdminPanelRoutes } from 'Pages/admin'
import { LeadRoutes } from 'Pages/lead'
import { PPRoutes } from 'Pages/pp'
import { OrdersRouterContainer } from 'Pages/orders_design/routes'
import { Page_404Component, Page_403Component, Page_500Component } from 'Components'
import { LazyRoute } from 'Modules'
import { OldGridRoutes } from 'Src/containers/Router'
import { ReferenceBookRoutes } from 'Pages/referenceBooks'
import { DepartmentRoutes } from 'Pages/departments'
import { BankEmployeesRoutes } from 'Pages/bankEmployees'
import { BusinessappsRoutes } from 'Pages/orders/businessapps/routes'
import { RegistryBusinessAccessRoutesNeo } from 'Pages/registry_business_access_neo/routes'
import { PartnerRequestRoutes } from 'Pages/partnerRequests'
import { OrderTaskStatsRoutes } from 'Pages/orderTasks'
import { AdvertisementRoutes } from 'Pages/advertisement/routes'
import { SomRoutes } from 'Pages/som'
import { SmsExpansionRoutes } from 'Pages/smsExpansion'
import { ProfileOrganizationRoutes } from 'Pages/profileOrganization'
import { ArchiveBrokerRoutes } from 'Pages/archiveBroker'
import { publicPartnerProfileRoutes } from 'Pages/partnerProfile'
import { PreloginRoutes } from 'Pages/prelogin'
import { InterfaceElementRoutes } from 'Pages/interfaceElement'
import { DashboardRoutes } from 'Pages/dashboard'
import { PartnerRoutes } from 'Pages/partner'
import { PartnersPersonalAccountRoutes } from 'Pages/partnersPersonalAccount'
import { UserRoutes } from 'Pages/user'

const BrokerRouterLazy = lazy(() => import('Pages/ibro/requests/routes'))
const BrokerLogsRouterLazy = lazy(() => import('Pages/ibro/logs/routes'))
const BrokerLimitRouterLazy = lazy(() => import('Pages/ibro/limitRequests/routes'))
const BgSettingsRouterLazy = lazy(() => import('Pages/ibro/settings/routes'))
const LogsCustomerIdentificationLazy = lazy(() =>
	import('Src/containers/LogsCustomerIdentification')
)
const HomeLazy = lazy(() => import('Src/containers/Common/Home'))
const ProfileLazy = lazy(() => import('Pages/profile/components/Profile'))
const RegistratorCabinetPaymentCallbackLazy = lazy(() =>
	import(
		'Pages/registratorCabinet/components/OrdersForm/OrderEditForms/PayProductForm/PaymentCallback'
	)
)

const AppRoutes = (
	<Switch>
		<LazyRoute exact path={FrontUrls.root} lazyComponent={HomeLazy} />
		<Route path={FrontUrls.dashboard} component={DashboardRoutes} />
		<LazyRoute path={FrontUrls.profile} lazyComponent={ProfileLazy} />
		<Route
			path={FrontUrls.cabinet_redesign.partners_personal_account}
			component={PartnersPersonalAccountRoutes}
		/>
		{PPRoutes}
		<Route path={FrontUrls.access} component={InterfaceElementRoutes} />
		{CompanyRoutes}
		<Route path={FrontUrls.knowledge.index} component={KnowledgesRoutes} />
		{BusinessappsRoutes}
		{LibraryRoutes}
		<Route path={FrontUrls.survey.index} component={SurveyRoutes} />
		{OrderTaskStatsRoutes}
		{SmsExpansionRoutes}
		{PreloginRoutes}
		{ProfileOrganizationRoutes}
		<Route path={FrontUrls.new_acts} component={ActsRoutes} />
		<Route path={FrontUrls.logs.index} component={LogsRoutes} />
		<Route path={FrontUrls.broker.index_neo} component={BrokerRouterLazy} />
		<Route path={FrontUrls.broker.logs} component={BrokerLogsRouterLazy} />
		<Route path={FrontUrls.broker.limits} component={BrokerLimitRouterLazy} />
		<Route path={FrontUrls.broker.settings} component={BgSettingsRouterLazy} />
		<Route path={FrontUrls.archive_orders} component={ArchiveBrokerRoutes} />
		<Route path={FrontUrls.pp.department} component={DepartmentRoutes} />
		<Route path={FrontUrls.bank_employees} component={BankEmployeesRoutes} />
		<Route path={FrontUrls.cabinet_redesign.lead_pro} component={LeadRoutes} />
		<Route path={FrontUrls.partner_request.index} component={PartnerRequestRoutes} />
		<Route path={FrontUrls.cabinet_redesign.cabinet} component={RegistratorCabinetRoutes} />
		<Route path={FrontUrls.admin_panel.index} component={AdminPanelRoutes} />
		<Route path={FrontUrls.admin_panel.index} component={SomRoutes} />
		{OldGridRoutes}
		<Route path={FrontUrls.orders.orders} component={OrdersRoutes} />
		<Route path={FrontUrls.orders.externalForms} component={ExternalFormsRoutes} />
		<Route path={FrontUrls.coliseum.index} component={ColiseumRoutes} />
		<LazyRoute
			path={FrontUrls.customer_identification_logs}
			lazyComponent={LogsCustomerIdentificationLazy}
		/>
		<Route path={FrontUrls.advertisment.index} component={AdvertisementRoutes} />
		<Route path={FrontUrls.referenceBook.index} component={ReferenceBookRoutes} />
		<Route path={FrontUrls.test} component={Test} />
		<Route path={FrontUrls.orders_redesign.index} component={OrdersRouterContainer} />
		<Route
			path={FrontUrls.cabinet_redesign.registry_business_access_neo_index}
			component={RegistryBusinessAccessRoutesNeo}
		/>
		<Route path={FrontUrls.pp.partner} component={PartnerRoutes} />
		<Route path={FrontUrls.user.index} component={UserRoutes} />
		<Route path={FrontUrls.pages.page_403} component={Page_403Component} />
		<Route path={FrontUrls.pages.page_500} component={Page_500Component} />
		<Route path="*" component={Page_404Component} />
	</Switch>
)

const publicRbidosPaymentRoutes = (
	<LazyRoute
		path={FrontUrls.cabinet_payment_callback}
		lazyComponent={RegistratorCabinetPaymentCallbackLazy}
	/>
)

const publicRoutes = (
	<Route
		exact
		path={`${FrontUrls.knowledge.index}/:slugProject/:slugArticle`}
		component={PublicPageContainer}
	/>
)

export { AppRoutes, publicRoutes, publicPartnerProfileRoutes, publicRbidosPaymentRoutes }
